/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-cohort.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const StudyCohortRecordChangeGrid = ({ oldRecord, newRecord }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              CfId: oldRecord.CfId?.$oid,
          }
        : null;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              CfId: newRecord.CfId?.$oid,
          }
        : null;
    return <FieldChangeGrid items={getFieldChangeItems(refactoredOldRecord, refactoredNewRecord)} />;
};

export { StudyCohortRecordChangeGrid };
